import React, { Fragment, useState } from "react";
import { useEffect } from "react";
import {
  Alert,
  Button,
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
  Row,
  Spinner,
} from "reactstrap";
import ModalConID from "../ModalConID";
import { useInsertConText } from "../../Context/InsertContext";
import ModalUser from "../SetCommander/ModalUser";
import axios from "axios";
import { GetCookieData, GetCookieToken } from "../../Cookie/GetCookie";
import { FetchAxiosGet, FetchAxiosPost, FetchAxiosPut } from "../../../api/axios";
import dayjs from "dayjs";
import LoadingData from "../../TESTPage/LoadingData";
import FadeIn from "react-fade-in/lib/FadeIn";
import MyThaiDatePick from "../../../components/Common/ThaiDatePicker";
import ConfirmModal from "../../../components/Common/ConfirmModal";
import LoadingPerson from "../../TESTPage/LoadingPerson";
import { CheckSubAdmin } from "../../Function/CheckSubAdmin";

const API_URL = process.env.REACT_APP_API_CORS;

function EditCommander(props) {
  const { id, onButtonClick, userDataID, OrgUserBase, ISdefaultSocheck } =
    props;
  const { insert, setInsert } = useInsertConText();
  const [open, setOpen] = useState(false);
  const [approveLeaveCheck, setApproveLeaveCheck] = useState(false);
  const [loading, setLoading] = useState(true);
  const [userName, setUserName] = useState(null);
  const [userID, setUserID] = useState(null);
  const [orgName, setOrgName] = useState(null);
  const [orgId, setOrgId] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [status, setStatus] = useState(null);
  const [isDefault, setIsDefault] = useState(null);
  const [position_Name, setPosition_Name] = useState(null);
  const [position_ID, setPosition_ID] = useState(null);
  const [masterdata, setMasterdata] = useState([]);
  const [userEditData, setUserEditData] = useState([]);
  const [editIDData, setEditIDData] = useState(null);
  const [editIDUser, setEditIDUser] = useState(null);
  const [editIDPosition, setEditIDPosition] = useState(null);
  const [editNamePosition, setEditNamePosition] = useState(null);
  const [editIsDefault, setEditIsDefault] = useState(null);
  const [editStartDate, setEditStartDate] = useState(null);
  const [editEndDate, setEditEndDate] = useState(null);
  const [editStatus, setEditStatus] = useState(null);
  const [editID, setEditID] = useState(null);
  const [subAdmin, setSubAdmin] = useState([]);
  const [subAdminCheck, setSubAdminCheck] = useState([]);
  const [conToPosition, setConToPosition] = useState([]);
  const [userDataOrg, setUserDataOrg] = useState([]);
  const [userDataOrgIsDeFault, setUserDataOrgIsDeFault] = useState([]);
  const [userDataOrgIsDeFaultOld, setUserDataOrgIsDeFaultOld] = useState([]);
  const [typeSubAdminAll, setTypeSubAdminAll] = useState(null);
  const [type1SubAdmin, setType1SubAdmin] = useState(null);
  const [type2SubAdmin, setType2SubAdmin] = useState(null);
  const [type3SubAdmin, setType3SubAdmin] = useState(null);
  const [type4SubAdmin, setType4SubAdmin] = useState(null);
  const [type5SubAdmin, setType5SubAdmin] = useState(null);
  const [type6SubAdmin, setType6SubAdmin] = useState(null);
  const [positionCheck, setPositionCheck] = useState(0);
  const [positionID1Check, setPositionID1Check] = useState(0);
  const [positionID2Check, setPositionID2Check] = useState(0);
  const [positionID3Check, setPositionID3Check] = useState(0);
  const [positionID4Check, setPositionID4Check] = useState(0);
  const [positionID5Check, setPositionID5Check] = useState(0);
  const [positionID6Check, setPositionID6Check] = useState(0);
  const [positionID7Check, setPositionID7Check] = useState(0);
  const [approveLeave, setApproveLeave] = useState(null);
  const [reportEntryExit, setReportEntryExit] = useState(null);
  const [statusCheck, setStatusCheck] = useState(false);

  const [confirmModal, setconfirmModal] = useState(false)

  const token = GetCookieToken("userToken");
  const userData = GetCookieData("userData");
  const filterSubAdmin = userData.positionSubAdmin.map(i => i.type_sub_admin);

  const toggleRightCanvasT = () => {
    setLoading(true);
    setOrgName(null);
    setTypeSubAdminAll(null);
    setType1SubAdmin(null);
    setType2SubAdmin(null);
    setType3SubAdmin(null);
    setType4SubAdmin(null);
    setType5SubAdmin(null);
    setType6SubAdmin(null);
    setStatus(null);
    fetchData();
    fetchMasterData();
    setOpen(true);

    setTimeout(() => {
      setLoading(false);
    }, 1500);
  };

  const toggleRightCanvasF = () => {
    setLoading(true);
    setOpen(false);
    setTypeSubAdminAll(null);
    setType1SubAdmin(null);
    setType2SubAdmin(null);
    setType3SubAdmin(null);
    setType4SubAdmin(null);
    setType5SubAdmin(null);
    setType6SubAdmin(null);
    setStatus(null);
    setInsert({ insert_name: null });
    onButtonClick(id);

    setTimeout(() => {
      setLoading(false);
    }, 2500);
  };

  const toggleRightCanvasFS = () => {
    setLoading(false);
    setApproveLeaveCheck(false);
    setTypeSubAdminAll(null);
    setType1SubAdmin(null);
    setType2SubAdmin(null);
    setType3SubAdmin(null);
    setType4SubAdmin(null);
    setType5SubAdmin(null);
    setType6SubAdmin(null);
    setStatus(null);
    // setOrgName(null);
    setInsert({ insert_name: null });
    setTimeout(() => {
      setLoading(false);
      setOpen(!open);
    }, 300);
  };

  const fetchData = () => {
    const url = `${API_URL}/api/users/position/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 1,
      "order[0]": "position_id",
      "order[1]": "ASC",
      "filter[id][0]": id,

      // search: pushkeyword,
      //   search: "ทดสอบระบบ",
    });
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    axios
      .get(url, config)
      .then(response => {
        setUserEditData(response.data.result);
        setEditIDUser(response.data.result?.map(i => i.user_id));
        setEditIDPosition(response.data.result?.map(i => i.position_id));
        setEditNamePosition(response.data.result?.map(i => i.position_name));
        setEditIsDefault(response.data.result?.map(i => i.is_default));
        setEditStartDate(response.data.result?.map(i => i.date_start));
        setEditEndDate(response.data.result?.map(i => i.date_end));
        setEditIDData(response.data.result?.map(i => i.org_id));
        setEditStatus(response.data.result?.map(i => i.status));
        setEditID(response.data.result?.map(i => i.id));
        // const userId = response.data.result?.map(i => i.user_id);
      })
      .catch(error => console.error("Error:", error));
  };

  const fetchMasterData = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/users/config/all`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setMasterdata(response.data.result);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // useEffect(() => {
  //   if(endDate === ""){
  //     setEndDate(null)
  //   }
  // }, [endDate])
  

  const data = {
    position_id: position_ID ? position_ID : `${editIDPosition}`,
    position_name: position_Name ? position_Name : `${editNamePosition}`,
    user_id: userID !== null ? userID : `${editIDUser}`,
    is_default: isDefault !== null ? isDefault : `${editIsDefault}`,
    date_start: startDate ? startDate : `${editStartDate}`,
    date_end: endDate !== null  ? endDate : null,
    org_id: orgId !== null ? orgId : `${editIDData}`,
    status: status !== null ? status : `${editStatus}`,
    approve_leave: approveLeave,
    report_entry_exit: reportEntryExit,
  };

  let filteredData = {};
  for (const key in data) {
    if (
      // key !== "date_end" || 
      data[key] !== null) {
      filteredData[key] = data[key];
    }
  }


  const SubAdminForFetch = (idSub, statusValue) => {
    const url = `${API_URL}/api/subAdmin/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 1000,
      "order[0]": "type_sub_admin",
      "order[1]": "ASC",
      "filter[type_sub_admin][0]": idSub,
      "filter[user_id][0]": editIDUser,
    });
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    axios
      .get(url, config)
      .then(response => {
        const TableSubAdminID = response.data.result.map(i => i.id);
        if (response.data.result.length !== 0) {
          const subAdmin_data_all = {
            user_id: userID !== null ? userID : `${editIDUser}`,
            date_start: startDate ? startDate : `${editStartDate}`,
            date_end: endDate ? endDate : `${editEndDate}`,
            status: statusValue !== null ? statusValue : `${editStatus}`,
            users_position_id: position_ID ? position_ID : `${editIDPosition}`,
            type_sub_admin: idSub,
            pk_user_position_id: id
          };
          const subAdminPutURL = `/api/subAdmin/${TableSubAdminID.toString()}`;
          if (TableSubAdminID !== null && TableSubAdminID !== undefined) {
            FetchAxiosPut(subAdminPutURL, subAdmin_data_all, token);
          }
        } else {
          const subAdminPostURL = "/api/subAdmin/save";
          const subAdmin_data_all = {
            user_id: userID !== null ? userID : `${editIDUser}`,
            date_start: startDate ? startDate : `${editStartDate}`,
            date_end: endDate ? endDate : `${editEndDate}`,
            status: status !== null ? status : `${editStatus}`,
            users_position_id: position_ID ? position_ID : `${editIDPosition}`,
            type_sub_admin: idSub,
            pk_user_position_id: id
          };
          FetchAxiosPost(subAdminPostURL, subAdmin_data_all, token);
        }
      })
      .catch(error => console.error("Error:", error));
  };

  const handleSubmit = async () => {
    const positionURL = `/api/users/position/${editID}`;
    FetchAxiosPut(positionURL, filteredData, token);

    if (status === 0) {
      const filteredSubAdmin = subAdmin.filter(item => item.status !== "0");
      filteredSubAdmin.map(i => SubAdminForFetch(i.type_sub_admin, 0));
    } else {
      if (typeSubAdminAll === "0") {
        SubAdminForFetch(typeSubAdminAll, status);
        const filteredSubAdmin = subAdmin.filter(
          item => item.type_sub_admin !== 0
        );
        filteredSubAdmin.map(i => SubAdminForFetch(i.type_sub_admin, 0));
      } else {
        if (typeSubAdminAll === "ไม่มีข้อมูล") {
          const filteredSubAdmin = subAdmin.filter(
            item => item.type_sub_admin === 0
          );
          const TypeIDfiltered = filteredSubAdmin.map(i => i.type_sub_admin);

          SubAdminForFetch(TypeIDfiltered.toString(), 0);
        }
      }
      if (type1SubAdmin === 1) {
        SubAdminForFetch(type1SubAdmin, status);
      } else {
        if (type1SubAdmin === "ไม่มีข้อมูล") {
          const filteredSubAdmin = subAdmin.filter(
            item => item.type_sub_admin === 1
          );
          const TypeIDfiltered = filteredSubAdmin.map(i => i.type_sub_admin);

          SubAdminForFetch(TypeIDfiltered.toString(), 0);
        }
      }
      if (type2SubAdmin === 2) {
        SubAdminForFetch(type2SubAdmin, status);
      } else {
        if (type2SubAdmin === "ไม่มีข้อมูล") {
          const filteredSubAdmin = subAdmin.filter(
            item => item.type_sub_admin === 2
          );
          const TypeIDfiltered = filteredSubAdmin.map(i => i.type_sub_admin);

          SubAdminForFetch(TypeIDfiltered.toString(), 0);
        }
      }
      if (type3SubAdmin === 3) {
        SubAdminForFetch(type3SubAdmin, status);
      } else {
        if (type3SubAdmin === "ไม่มีข้อมูล") {
          const filteredSubAdmin = subAdmin.filter(
            item => item.type_sub_admin === 3
          );
          const TypeIDfiltered = filteredSubAdmin.map(i => i.type_sub_admin);

          SubAdminForFetch(TypeIDfiltered.toString(), 0);
        }
      }
      if (type4SubAdmin === 4) {
        SubAdminForFetch(type4SubAdmin, status);
      } else {
        if (type4SubAdmin === "ไม่มีข้อมูล") {
          const filteredSubAdmin = subAdmin.filter(
            item => item.type_sub_admin === 4
          );
          const TypeIDfiltered = filteredSubAdmin.map(i => i.type_sub_admin);

          SubAdminForFetch(TypeIDfiltered.toString(), 0);
        }
      }
      if (type5SubAdmin === 5) {
        SubAdminForFetch(type5SubAdmin, status);
      } else {
        if (type5SubAdmin === "ไม่มีข้อมูล") {
          const filteredSubAdmin = subAdmin.filter(
            item => item.type_sub_admin === 5
          );
          const TypeIDfiltered = filteredSubAdmin.map(i => i.type_sub_admin);

          SubAdminForFetch(TypeIDfiltered.toString(), 0);
        }
      }
      if (type6SubAdmin === 6) {
        SubAdminForFetch(type6SubAdmin, status);
      } else {
        if (type6SubAdmin === "ไม่มีข้อมูล") {
          const filteredSubAdmin = subAdmin.filter(
            item => item.type_sub_admin === 6
          );
          const TypeIDfiltered = filteredSubAdmin.map(i => i.type_sub_admin);

          SubAdminForFetch(TypeIDfiltered.toString(), 0);
        }
      }
    }

    if (conToPosition.length !== 0 && userID !== null) {
      const contoURLDel = `/api/users/${userID}`;
      let arrayPosition = [2,3,4,5,6,7]
      let data_con_to_id_Del = {
        user_title_id: conToPosition.user_title_id,
        user_title_name: conToPosition.user_title_name,
        user_name: conToPosition.user_name,
        user_idcard: conToPosition.user_idcard,
        user_email: conToPosition.user_email,
        user_login: conToPosition.user_login,
        cont_to_id: 0,
      };
      
      arrayPosition.forEach(element => { data_con_to_id_Del[`cont_to_id${element}`] = 0 });
      await  FetchAxiosPut(contoURLDel, data_con_to_id_Del, token);
          let resultArray;
          let data_con_to_id_Edit = {
                user_title_id: conToPosition.user_title_id,
                user_title_name: conToPosition.user_title_name,
                user_name: conToPosition.user_name,
                user_idcard: conToPosition.user_idcard,
                user_email: conToPosition.user_email,
                user_login: conToPosition.user_login,
              };
          if (orgId !== null && isDefault === 1 ) {
              data_con_to_id_Edit.cont_to_id = orgId
              resultArray = userDataOrg.filter(item => ![orgId]?.includes(item));
          } else if (orgId !== null && isDefault === 0 ) {
                if (userDataOrgIsDeFaultOld.length > 0) {
                  data_con_to_id_Edit.cont_to_id = Number(userDataOrgIsDeFaultOld)
                  resultArray = userDataOrg.filter(item => !userDataOrgIsDeFaultOld?.includes(item));
                      if (status === 1 && userDataOrgIsDeFault.length > 0) {
                        data_con_to_id_Edit.cont_to_id = Number(userDataOrgIsDeFault)
                        resultArray = userDataOrg.filter(item => !userDataOrgIsDeFault?.includes(item));
                      } else {
                        data_con_to_id_Edit.cont_to_id = orgId
                        resultArray = userDataOrg.filter(item => ![orgId]?.includes(item));
                      }
                } else {
                  data_con_to_id_Edit.cont_to_id = orgId
                  resultArray = userDataOrg.filter(item => ![orgId]?.includes(item));
                }
          } else {
              data_con_to_id_Edit.cont_to_id = orgId
                if (status === 1 && isDefault === 1) {
                    data_con_to_id_Edit.cont_to_id = orgId
                    resultArray = userDataOrg.filter(item => ![orgId]?.includes(item));
                } else {
                    if (userDataOrgIsDeFault.length > 0) {
                      data_con_to_id_Edit.cont_to_id = Number(userDataOrgIsDeFault)
                      resultArray = userDataOrg.filter(item => !userDataOrgIsDeFault?.includes(item));
                      let updatedArray = resultArray.filter(item => item !== OrgUserBase);
                      updatedArray.unshift(orgId);
                      resultArray = updatedArray
                    } else {
                        if (status === 0 || userEditData[0].status === 0) {
                          resultArray = userDataOrg.filter(item => ![OrgUserBase]?.includes(item));
                        } else {
                          resultArray = userDataOrg.filter(item => !userDataOrgIsDeFaultOld?.includes(item));
                        }
                      
                    }
                }
          }

          const newUniqueArray = resultArray.filter(item => item !== OrgUserBase);
          if (newUniqueArray.length > 0) {
            for (let index = 0; index < newUniqueArray?.length; index++) {
              const element = newUniqueArray[index];
              data_con_to_id_Edit[`cont_to_id${2 + index}`] = element 
            }
          }
          
          // for (let index = 0; index < resultArray?.length; index++) {
          //   const element = resultArray[index];
          //   data_con_to_id_Edit[`cont_to_id${2 + index}`] = element 
          // }
          FetchAxiosPut(contoURLDel, data_con_to_id_Edit, token);

    }

    let params = new URLSearchParams({
      page: 1,
      size: 10,
      "order[0]": "id",
      "order[1]": "ASC",
      "filter[org_id][0]": orgId !== null ? orgId : `${editIDData}`, 
      "filter[position_id][0]": position_ID ? position_ID : `${editIDPosition}`, 
      "filter[status][0]": "1", 
    })
    const fetchDateCancle = await FetchAxiosGet('/api/users/position/datatable', token, params)
    if (fetchDateCancle.result.length > 1) {
        for (let index = 0; index < fetchDateCancle.result.length; index++) {
          const element = fetchDateCancle.result[index];
          const elementLast = fetchDateCancle.result[fetchDateCancle.result.length - 1];
          if (Number(userID) !== Number(element.user_id)) {
            const originalDate = new Date(elementLast.date_start);
            originalDate.setDate(originalDate.getDate() - 1);
            const urlEdit = `/api/users/position/${element.id}`
            const dataEdit =  {
              position_id: element.position_id,
              position_name: element.position_name,
              user_id: element.user_id,
              is_default: element.is_default,
              date_start: element.date_start,
              date_end: originalDate.toISOString(),
              org_id: element.org_id,
              status: "0",
            }
            const fetchEditCancelDate = await FetchAxiosPut(urlEdit,dataEdit,token)
          }
        }
    }

    setTimeout(() => {
      setUserID(null);
      setUserName(null);
      setOrgId(null);
      setOrgName(null);
    }, 500);
  };

  const OrgFuctionName = id => {
    const url = `${API_URL}/api/users/${id}`;
    const params = new URLSearchParams({});
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    axios
      .get(url, config)
      .then(response => {
        setConToPosition(response.data.result);
      })
      .catch(error => {
        console.error(error);
      });
  };
  

  const checkOrgUserPosition = async id => {
    const url = `${API_URL}/api/users/position/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 1000,
      "order[0]": "id",
      "order[1]": "ASC",
      "filter[assign][0]": "0",
      "filter[user_id][0]": id,
    });
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    await axios
      .get(url, config)
      .then(response => {
        const uniqueOrgIds = new Set(
          response.data.result.map(item => item.org_id)
        );
        const uniqueOrgIdsArray = Array.from(uniqueOrgIds);

        setUserDataOrg(uniqueOrgIdsArray);
      })
      .catch(error => console.error("Error:", error));
  };

  const checkOrgUserIsDefaultPosition = async id => {
    const url = `${API_URL}/api/users/position/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 1000,
      "order[0]": "id",
      "order[1]": "ASC",
      "filter[assign][0]": "0",
      "filter[is_default][0]": "1",
      "filter[user_id][0]": id,
      // "filter[status][0]": "1",
    });
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    await axios
      .get(url, config)
      .then(response => {
        if (response.data.result.find( i => i.status === 0)) {
          setUserDataOrgIsDeFaultOld([response.data.result.find( i => i.status === 0).org_id])
        } 
        if (response.data.result.find( i => i.status === 1)) {
          setUserDataOrgIsDeFault([response.data.result.find( i => i.status === 1).org_id]);
        } 
        // const userId = response.data.result?.map(i => i.user_id);
      })
      .catch(error => console.error("Error:", error));
  };

  useEffect(() => {
    setLoading(true);
    if (insert.task === "สำนัก/กอง/กลุ่ม_ผู้บังคับบัญชา") {
      setOrgId(insert.insert_id);
      if (insert.insert_name !== undefined && insert.insert_name !== null) {
        const test = insert.insert_name?.split(",");
        setOrgName(() => test[0]);
      }
      // setOrgName(insert.insert_name);
    }
    if (insert.task === "user_ผู้บังคับบัญชา") {
      setUserID(insert.insert_id);
      setUserName(insert.insert_name);
    }
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [insert, userName]);

  const fetchOrgData = async (id, setValue) => {
    try {
      const response = await axios.get(`${API_URL}/api/orgInner/id/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (id !== 0 && id !== null) {
        setValue(response.data.result.org_name);
        setOrgId(response.data.result.org_id);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const fetchDataUser = async (id, setValue) => {
    const url = `${API_URL}/api/users/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 1,
      "order[0]": "user_name",
      "order[1]": "ASC",
      "filter[user_id][0]": id,
    });
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    await axios
      .get(url, config)
      .then(response => {
        setValue(() => response.data.result?.map(i => i.user_name));
        setUserID(() => Number(response.data.result?.map(i => i.user_id)))
      })
      .catch(error => console.error("Error:", error));
  };

  useEffect(() => {
    if (editIDData !== null) {
      fetchOrgData(parseInt(editIDData), setOrgName);
    }
  }, [editIDData]);

  useEffect(() => {
    if (editIDUser !== null) {
      fetchDataUser(editIDUser, setUserName);
    }
  }, [editIDUser]);

  useEffect(() => {
    const EditPositonCheck = userEditData.map(userEdit => userEdit.position_id);
    if (`${EditPositonCheck}` === "1") {
      setPositionCheck(status);
      setPositionID1Check(2);
      setPositionID2Check(3);
      setPositionID3Check(4);
      setPositionID4Check(5);
      setPositionID5Check(6);
      setPositionID6Check(7);
      setPositionID7Check(8);
    }
    if (`${EditPositonCheck}` === "2") {
      setPositionCheck(2);
      setPositionID1Check(1);
      setPositionID2Check(3);
      setPositionID3Check(4);
      setPositionID4Check(5);
      setPositionID5Check(6);
      setPositionID6Check(7);
      setPositionID7Check(8);
    }
    if (`${EditPositonCheck}` === "3") {
      setPositionCheck(3);
      setPositionID1Check(2);
      setPositionID2Check(1);
      setPositionID3Check(4);
      setPositionID4Check(5);
      setPositionID5Check(6);
      setPositionID6Check(7);
      setPositionID7Check(8);
    }
    if (`${EditPositonCheck}` === "4") {
      setPositionCheck(4);
      setPositionID1Check(2);
      setPositionID2Check(3);
      setPositionID3Check(1);
      setPositionID4Check(5);
      setPositionID5Check(6);
      setPositionID6Check(7);
      setPositionID7Check(8);
    }
    if (`${EditPositonCheck}` === "5") {
      setPositionCheck(5);
      setPositionID1Check(2);
      setPositionID2Check(3);
      setPositionID3Check(4);
      setPositionID4Check(1);
      setPositionID5Check(6);
      setPositionID6Check(7);
      setPositionID7Check(8);
    }
    if (`${EditPositonCheck}` === "6") {
      setPositionCheck(6);
      setPositionID1Check(2);
      setPositionID2Check(3);
      setPositionID3Check(4);
      setPositionID4Check(5);
      setPositionID5Check(1);
      setPositionID6Check(7);
      setPositionID7Check(8);
    }
    if (`${EditPositonCheck}` === "7") {
      setPositionCheck(7);
      setPositionID1Check(2);
      setPositionID2Check(3);
      setPositionID3Check(4);
      setPositionID4Check(5);
      setPositionID5Check(6);
      setPositionID6Check(1);
      setPositionID7Check(8);
    }
    if (`${EditPositonCheck}` === "8") {
      setPositionCheck(8);
      setPositionID1Check(2);
      setPositionID2Check(3);
      setPositionID3Check(4);
      setPositionID4Check(5);
      setPositionID5Check(6);
      setPositionID6Check(7);
      setPositionID7Check(1);
    }
  }, [userEditData]);

  const fetchSubAdmin = id => {
    const url = `${API_URL}/api/subAdmin/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 1000,
      "order[0]": "type_sub_admin",
      "order[1]": "ASC",
      "filter[user_id][0]": id,
    });
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    axios
      .get(url, config)
      .then(response => {
        setSubAdmin(() => response.data.result);
        setSubAdminCheck(() => response.data.result);
        const filteredSubAdmin = response.data.result.filter(
          item => item.type_sub_admin === 0
        );
        const TypeIDfiltered = filteredSubAdmin.map(i => i.type_sub_admin);
        const TypeStatusfiltered = filteredSubAdmin.map(i => i.status);
        if (
          TypeIDfiltered.toString() !== null &&
          TypeIDfiltered.toString() !== undefined &&
          TypeStatusfiltered.toString() !== "0"
        ) {
          setTypeSubAdminAll(String(TypeIDfiltered));
        }
      })
      .catch(error => console.error("Error:", error));
  };

  useEffect(() => {
    if (editIDUser !== null) {
      fetchSubAdmin(editIDUser);
    }
  }, [editIDUser]);

  // const filteredSubAdmin = subAdmin.filter(item => item.status !== "0");


  // useEffect(() => {
  //   if (endDate !== null) {
  //     setEndDate(null);
  //     setEditEndDate(null);
  //   }
  // }, [endDate]);


  useEffect(() => {
    if (status !== null) {
      if (status === 0) {
        setStatusCheck(true);
      }
      // setEndDate(null);
      // setUserEditData({ status: status });
      // setEditEndDate(null);
    }
  }, [status]);

  useEffect(() => {
    OrgFuctionName(userDataID);
    checkOrgUserPosition(userDataID);
    checkOrgUserIsDefaultPosition(userDataID);
  }, [userDataID]);

  useEffect(() => {
    checkOrgUserPosition(userDataID)
  }, [orgId])
  

  return (
    <Fragment>
      <Button
        className="mt-1 me-2"
        onClick={toggleRightCanvasT}
        color="warning"
      >
        <i className="fa-solid fa-pen-to-square"></i>
      </Button>
      <Offcanvas
        style={{ border: "none" }}
        autoFocus
        direction="end"
        isOpen={open}
        toggle={toggleRightCanvasFS}
        fade
        className="fade custom-w-50"
      >
        <OffcanvasHeader style={{ background: "#2a3042", color: "white" }}>
          <i className="fa-solid fa-plus"></i> รายละเอียดข้อมูลผู้บังคับบัญชา
          <div className="position-absolute top-0 end-0">
            <i className="fa-sharp fa-solid fa-circle-xmark pt-3 pe-3 h4" style={{cursor: "pointer"}} onClick={toggleRightCanvasFS}></i>
          </div>
        </OffcanvasHeader>
        <OffcanvasBody>
          {loading ? (
            // <div
            //   style={{
            //     display: "flex",
            //     justifyContent: "center",
            //     alignItems: "center",
            //     minHeight: "400px",
            //   }}
            // >
            //   <LoadingData />
            // </div>
            <LoadingPerson />
          ) : (
            <FadeIn>
              <ConfirmModal
                 modal = {confirmModal}
                 modalSize = "md"
                 modalHeaderContent = "คุณต้องการที่จะแก้ไข ใช่หรือไม่?"
                 onClickConfirmBtn={() => {
                  handleSubmit();
                  toggleRightCanvasF();
                  setconfirmModal(false)
                 }}
                 onClickCancelBtn={() => {
                   setconfirmModal(false)
                 }}
                />
              <Form
                onSubmit={e => {
                  e.preventDefault();
                  setconfirmModal(true)
                }}
              >
                <Row>
                  <Col lg={12}>
                    <FormGroup>
                      <Label>เจ้าหน้าที่</Label>
                      <InputGroup>
                        <Input
                          // readOnly
                          disabled
                          defaultValue={userName}
                          name="user_name"
                          placeholder="กรุณาใส่ชื่อเล่น..."
                          type="text"
                        />
                        {/* <ModalUser task="user_ผู้บังคับบัญชา" /> */}
                      </InputGroup>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <FormGroup>
                      <Label>สำนัก/กอง/กลุ่ม</Label>
                      <InputGroup>
                        <Input
                          readOnly
                          // defaultValue={orgName ? orgName[0] : orgName}
                          defaultValue={orgName}
                          name="org_name"
                          placeholder="กรุณาใส่ชื่อเล่น..."
                          type="text"
                        />
                        <ModalConID task="สำนัก/กอง/กลุ่ม_ผู้บังคับบัญชา" taskFilter = "NEED_ADMINISTER"/>
                      </InputGroup>
                    </FormGroup>
                  </Col>
                </Row>
                {userEditData.map((userEdit, index) => {
                  return (
                    <Fragment key={`masterdata-${index}`}>
                      <Row>
                        <Col lg={12}>
                          <FormGroup>
                            {masterdata.users_position?.map(
                              (masterdata, index) => (
                                <InputGroup className="my-2" key={index}>
                                  {masterdata.users_position_id !== 1 ? (
                                    // &&
                                    // masterdata.users_position_id !== 8
                                    userEdit.position_id === positionCheck &&
                                    masterdata.users_position_id !==
                                      positionID1Check &&
                                    masterdata.users_position_id !==
                                      positionID2Check &&
                                    masterdata.users_position_id !==
                                      positionID3Check &&
                                    masterdata.users_position_id !==
                                      positionID4Check &&
                                    masterdata.users_position_id !==
                                      positionID5Check &&
                                    masterdata.users_position_id !==
                                      positionID6Check &&
                                    masterdata.users_position_id !==
                                      positionID7Check ? (
                                      <>
                                        <InputGroup>
                                          <InputGroupText>
                                            <Input
                                              addon
                                              defaultChecked
                                              type="radio"
                                              name="users_position_id"
                                              onChange={e => {
                                                setPosition_ID(
                                                  e.target.checked
                                                    ? masterdata.users_position_id
                                                    : null
                                                );
                                                setPosition_Name(
                                                  e.target.checked
                                                    ? masterdata.users_position_name
                                                    : null
                                                );
                                                // setCheckSubAdmin(true);
                                              }}
                                            />
                                          </InputGroupText>
                                          <Input
                                            readOnly
                                            defaultValue={
                                              masterdata.users_position_name
                                            }
                                            style={{
                                              cursor: "pointer",
                                              transition:
                                                "background-color 0.3s",
                                            }}
                                          />
                                        </InputGroup>
                                      </>
                                    ) : masterdata.users_position_id !==
                                      positionCheck ? (
                                      <>
                                        <InputGroup>
                                          <InputGroupText>
                                            <Input
                                              addon
                                              // defaultChecked={userEdit.position_id}
                                              type="radio"
                                              name="users_position_id"
                                              onChange={e => {
                                                setPosition_ID(
                                                  e.target.checked
                                                    ? masterdata.users_position_id
                                                    : null
                                                );
                                                setPosition_Name(
                                                  e.target.checked
                                                    ? masterdata.users_position_name
                                                    : null
                                                );
                                                if (e.target.checked === 8) {
                                                  setApproveLeaveCheck(false);
                                                } else {
                                                  setApproveLeaveCheck(true);
                                                }
                                                // setCheckSubAdmin(false);
                                              }}
                                            />
                                          </InputGroupText>
                                          <Input
                                            readOnly
                                            defaultValue={
                                              masterdata.users_position_name
                                            }
                                            style={{
                                              cursor: "pointer",
                                              transition:
                                                "background-color 0.3s",
                                            }}
                                          />
                                        </InputGroup>
                                      </>
                                    ) : (
                                      ""
                                    )
                                  ) : (
                                    ""
                                  )}
                                </InputGroup>
                              )
                            )}

                            {(userEdit.position_id === 8 &&
                              approveLeaveCheck === false) ||
                            position_ID === 8 ? (
                              <Row>
                                <Col lg={6}>
                                  <InputGroup className="my-2">
                                    <InputGroupText>
                                      <Input
                                        defaultChecked={
                                          userEdit.approve_leave === 1
                                        }
                                        addon
                                        type="checkbox"
                                        name="approve_leave"
                                        onChange={e => {
                                          setApproveLeave(
                                            e.target.checked ? 1 : 0
                                          );
                                        }}
                                      />
                                    </InputGroupText>
                                    <Input
                                      readOnly
                                      defaultValue={"มีสิทธิ์อนุมัติการลา"}
                                      style={{
                                        cursor: "pointer",
                                        transition: "background-color 0.3s",
                                      }}
                                    />
                                  </InputGroup>
                                </Col>

                                <Col lg={6}>
                                  <InputGroup className="my-2">
                                    <InputGroupText>
                                      <Input
                                        addon
                                        type="checkbox"
                                        defaultChecked={
                                          userEdit.report_entry_exit === 1
                                        }
                                        name="report_entry_exit"
                                        onChange={e => {
                                          setReportEntryExit(
                                            e.target.checked ? 1 : 0
                                          );
                                        }}
                                      />
                                    </InputGroupText>
                                    <Input
                                      readOnly
                                      defaultValue={"รายงานการเข้าออก"}
                                      style={{
                                        cursor: "pointer",
                                        transition: "background-color 0.3s",
                                      }}
                                    />
                                  </InputGroup>
                                </Col>
                              </Row>
                            ) : (
                              ""
                            )}
                            { CheckSubAdmin(userData?.positionSubAdmin).length > 0 && CheckSubAdmin(userData?.positionSubAdmin).includes(0) && !CheckSubAdmin(userData?.positionSubAdmin).includes(5) ?
                            // filterSubAdmin.length > 0 && Number(filterSubAdmin) === 5 ?
                              <Fragment>
                                {/* {editStatus.toString() === "0" && status !== 1 ? ( */}
                                {editStatus == 0 && status != 1 ? (
                              <>
                                <FormGroup>
                                  <Label>ผู้ดูแลระบบย่อย</Label>
                                  <InputGroup className="mb-1">
                                    <InputGroupText>
                                      <Input
                                        name="users_position_sub_admin"
                                        type="checkbox"
                                        addon
                                        disabled={
                                          editStatus.toString() === "0"
                                            ? // editStatus.toString() === "0"
                                              true
                                            : false
                                        }
                                        defaultChecked={
                                          typeSubAdminAll === "ไม่มีข้อมูล"
                                            ? false
                                            : subAdminCheck.some(
                                                i =>
                                                  i.type_sub_admin === 0 &&
                                                  i.status !== "0"
                                              )
                                        }
                                        // checked={
                                        //   typeSubAdminAll === "ไม่มีข้อมูล"
                                        //     ? false
                                        //     : typeSubAdminAll
                                        // }
                                        onChange={e => {
                                          const isChecked = e.target.checked;
                                          setTypeSubAdminAll(
                                            isChecked ? "0" : "ไม่มีข้อมูล"
                                          );

                                          if (isChecked) {
                                            [
                                              // setType1SubAdminCheck,
                                              setType1SubAdmin,
                                              setType2SubAdmin,
                                              setType3SubAdmin,
                                              setType4SubAdmin,
                                              setType5SubAdmin,
                                              setType6SubAdmin,
                                              // setSubAdminCheck,
                                            ].forEach(setType => {
                                              setType(false);
                                            });
                                          }
                                        }}
                                      ></Input>
                                    </InputGroupText>

                                    <Input
                                      readOnly
                                      disabled={
                                        editStatus.toString() === "0"
                                          ? true
                                          : false
                                      }
                                      placeholder="ผู้ดูแลระบบงานทั้งหมด"
                                    />
                                  </InputGroup>

                                  <InputGroup className="mb-1">
                                    <InputGroupText>
                                      <Input
                                        disabled={
                                          typeSubAdminAll === "0" ||
                                          editStatus.toString() === "0"
                                            ? true
                                            : false
                                        }
                                        name="users_position_sub_admin"
                                        type="checkbox"
                                        addon
                                        defaultChecked={
                                          subAdminCheck.some(
                                            i =>
                                              i.type_sub_admin === 1 &&
                                              i.status !== "0"
                                          )
                                          // && type1SubAdminCheck
                                        }
                                        // checked={
                                        //   type1SubAdmin === "ไม่มีข้อมูล"
                                        //     ? false
                                        //     : type1SubAdmin
                                        // }
                                        onChange={e =>
                                          setType1SubAdmin(
                                            e.target.checked ? 1 : "ไม่มีข้อมูล"
                                          )
                                        }
                                      ></Input>
                                    </InputGroupText>

                                    <Input
                                      disabled={
                                        typeSubAdminAll === "0" ||
                                        editStatus.toString() === "0"
                                          ? true
                                          : false
                                      }
                                      readOnly
                                      placeholder="ระบบลาออนไลน์"
                                    />
                                  </InputGroup>
                                  <InputGroup className="mb-1">
                                    <InputGroupText>
                                      <Input
                                        disabled={
                                          typeSubAdminAll === "0" ||
                                          editStatus.toString() === "0"
                                            ? true
                                            : false
                                        }
                                        name="users_position_sub_admin"
                                        type="checkbox"
                                        addon
                                        defaultChecked={subAdminCheck.some(
                                          i =>
                                            i.type_sub_admin === 2 &&
                                            i.status !== "0"
                                        )}
                                        // checked={
                                        //   type2SubAdmin === "ไม่มีข้อมูล"
                                        //     ? false
                                        //     : type2SubAdmin
                                        // }
                                        onChange={e =>
                                          setType2SubAdmin(
                                            e.target.checked ? 2 : "ไม่มีข้อมูล"
                                          )
                                        }
                                      ></Input>
                                    </InputGroupText>

                                    <Input
                                      disabled={
                                        typeSubAdminAll === "0" ||
                                        editStatus.toString() === "0"
                                          ? true
                                          : false
                                      }
                                      readOnly
                                      placeholder="ระบบลงเวลาปฏิบัติงานแบบยืดหยุ่น"
                                    />
                                  </InputGroup>
                                  <InputGroup className="mb-1">
                                    <InputGroupText>
                                      <Input
                                        disabled={
                                          typeSubAdminAll === "0" ||
                                          editStatus.toString() === "0"
                                            ? true
                                            : false
                                        }
                                        name="users_position_sub_admin"
                                        type="checkbox"
                                        addon
                                        defaultChecked={subAdminCheck.some(
                                          i =>
                                            i.type_sub_admin === 3 &&
                                            i.status !== "0"
                                        )}
                                        // checked={
                                        //   type3SubAdmin === "ไม่มีข้อมูล"
                                        //     ? false
                                        //     : type3SubAdmin
                                        // }
                                        onChange={e =>
                                          setType3SubAdmin(
                                            e.target.checked ? 3 : "ไม่มีข้อมูล"
                                          )
                                        }
                                      ></Input>
                                    </InputGroupText>

                                    <Input
                                      disabled={
                                        typeSubAdminAll === "0" ||
                                        editStatus.toString() === "0"
                                          ? true
                                          : false
                                      }
                                      readOnly
                                      placeholder="ระบบการประเมินผล การปฏิบัติราชการแบบออนไลน์"
                                    />
                                  </InputGroup>
                                  <InputGroup className="mb-1">
                                    <InputGroupText>
                                      <Input
                                        disabled={
                                          typeSubAdminAll === "0" ||
                                          editStatus.toString() === "0"
                                            ? true
                                            : false
                                        }
                                        name="users_position_sub_admin"
                                        type="checkbox"
                                        addon
                                        defaultChecked={subAdminCheck.some(
                                          i =>
                                            i.type_sub_admin === 4 &&
                                            i.status !== "0"
                                        )}
                                        // checked={
                                        //   type4SubAdmin === "ไม่มีข้อมูล"
                                        //     ? false
                                        //     : type4SubAdmin
                                        // }
                                        onChange={e =>
                                          setType4SubAdmin(
                                            e.target.checked ? 4 : "ไม่มีข้อมูล"
                                          )
                                        }
                                      ></Input>
                                    </InputGroupText>

                                    <Input
                                      disabled={
                                        typeSubAdminAll === "0" ||
                                        editStatus.toString() === "0"
                                          ? true
                                          : false
                                      }
                                      readOnly
                                      placeholder="ระบบทรัพยากรออนไลน์"
                                    />
                                  </InputGroup>
                                  <InputGroup className="mb-1">
                                    <InputGroupText>
                                      <Input
                                        disabled={
                                          typeSubAdminAll === "0" ||
                                          editStatus.toString() === "0"
                                            ? true
                                            : false
                                        }
                                        name="users_position_sub_admin"
                                        type="checkbox"
                                        addon
                                        defaultChecked={subAdminCheck.some(
                                          i =>
                                            i.type_sub_admin === 5 &&
                                            i.status !== "0"
                                        )}
                                        // checked={
                                        //   type4SubAdmin === "ไม่มีข้อมูล"
                                        //     ? false
                                        //     : type4SubAdmin
                                        // }
                                        onChange={e =>
                                          setType5SubAdmin(
                                            e.target.checked ? 5 : "ไม่มีข้อมูล"
                                          )
                                        }
                                      ></Input>
                                    </InputGroupText>

                                    <Input
                                      disabled={
                                        typeSubAdminAll === "0" ||
                                        editStatus.toString() === "0"
                                          ? true
                                          : false
                                      }
                                      readOnly
                                      placeholder="ระบบจัดการข้อมูล"
                                    />
                                  </InputGroup>

                                  <InputGroup className="mb-1">
                                    <InputGroupText>
                                      <Input
                                        disabled={
                                          typeSubAdminAll === "0" ||
                                          editStatus.toString() === "0"
                                            ? true
                                            : false
                                        }
                                        name="users_position_sub_admin"
                                        type="checkbox"
                                        addon
                                        defaultChecked={subAdminCheck.some(
                                          i =>
                                            i.type_sub_admin === 6 &&
                                            i.status !== "0"
                                        )}
                                        // checked={
                                        //   type4SubAdmin === "ไม่มีข้อมูล"
                                        //     ? false
                                        //     : type4SubAdmin
                                        // }
                                        onChange={e =>
                                          setType6SubAdmin(
                                            e.target.checked ? 6 : "ไม่มีข้อมูล"
                                          )
                                        }
                                      ></Input>
                                    </InputGroupText>

                                    <Input
                                      disabled={
                                        typeSubAdminAll === "0" ||
                                        editStatus.toString() === "0"
                                          ? true
                                          : false
                                      }
                                      readOnly
                                      placeholder="ระบบจัดการไฟล์เงินเดือน"
                                    />
                                  </InputGroup>
                                </FormGroup>
                                {editStatus.toString() === "0" ? (
                                  <div id="liveAlertPlaceholder">
                                    <Alert
                                      color="danger"
                                      className="text-danger"
                                      isOpen={editStatus.toString() === "0"}
                                    >
                                      ต้องเปิดการใช้งานจึงจะสามารถเลือกผู้ดูแลระบบย่อยได้
                                    </Alert>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </>
                                ) : (
                                  ""
                                )}
                                {/* {status === 1 || editStatus.toString() === "1" || (filterSubAdmin.length > 0 && !(Number(filterSubAdmin) === 5)) ? ( */}
                                {status == 1 || editStatus == 1  ? (
                                  <>
                                    <FormGroup>
                                      <Label>ผู้ดูแลระบบย่อย</Label>
                                      <InputGroup className="mb-1">
                                        <InputGroupText>
                                          <Input
                                            name="users_position_sub_admin"
                                            type="checkbox"
                                            addon
                                            disabled={
                                              status === 0
                                                ? // editStatus.toString() === "0"
                                                  true
                                                : false
                                            }
                                            defaultChecked={
                                              typeSubAdminAll === "ไม่มีข้อมูล"
                                                ? false
                                                : subAdminCheck.some(
                                                    i =>
                                                      i.type_sub_admin === 0 &&
                                                      i.status !== "0"
                                                  )
                                            }
                                            // checked={
                                            //   typeSubAdminAll === "ไม่มีข้อมูล"
                                            //     ? false
                                            //     : typeSubAdminAll
                                            // }
                                            onChange={e => {
                                              const isChecked = e.target.checked;
                                              setTypeSubAdminAll(
                                                isChecked ? "0" : "ไม่มีข้อมูล"
                                              );

                                              if (isChecked) {
                                                [
                                                  // setType1SubAdminCheck,
                                                  setType1SubAdmin,
                                                  setType2SubAdmin,
                                                  setType3SubAdmin,
                                                  setType4SubAdmin,
                                                  setType5SubAdmin,
                                                  setType6SubAdmin,
                                                  // setSubAdminCheck,
                                                ].forEach(setType => {
                                                  setType(false);
                                                });
                                              }
                                            }}
                                          ></Input>
                                        </InputGroupText>

                                        <Input
                                          readOnly
                                          disabled={status === 0 ? true : false}
                                          placeholder="ผู้ดูแลระบบงานทั้งหมด"
                                        />
                                      </InputGroup>

                                      <InputGroup className="mb-1">
                                        <InputGroupText>
                                          <Input
                                            disabled={
                                              typeSubAdminAll === "0" ||
                                              status === 0
                                                ? true
                                                : false
                                            }
                                            name="users_position_sub_admin"
                                            type="checkbox"
                                            addon
                                            defaultChecked={
                                              subAdminCheck.some(
                                                i =>
                                                  i.type_sub_admin === 1 &&
                                                  i.status !== "0"
                                              )
                                              // && type1SubAdminCheck
                                            }
                                            // checked={
                                            //   type1SubAdmin === "ไม่มีข้อมูล"
                                            //     ? false
                                            //     : type1SubAdmin
                                            // }
                                            onChange={e =>
                                              setType1SubAdmin(
                                                e.target.checked ? 1 : "ไม่มีข้อมูล"
                                              )
                                            }
                                          ></Input>
                                        </InputGroupText>

                                        <Input
                                          disabled={
                                            typeSubAdminAll === "0" || status === 0
                                              ? true
                                              : false
                                          }
                                          readOnly
                                          placeholder="ระบบลาออนไลน์"
                                        />
                                      </InputGroup>
                                      <InputGroup className="mb-1">
                                        <InputGroupText>
                                          <Input
                                            disabled={
                                              typeSubAdminAll === "0" ||
                                              status === 0
                                                ? true
                                                : false
                                            }
                                            name="users_position_sub_admin"
                                            type="checkbox"
                                            addon
                                            defaultChecked={subAdminCheck.some(
                                              i =>
                                                i.type_sub_admin === 2 &&
                                                i.status !== "0"
                                            )}
                                            // checked={
                                            //   type2SubAdmin === "ไม่มีข้อมูล"
                                            //     ? false
                                            //     : type2SubAdmin
                                            // }
                                            onChange={e =>
                                              setType2SubAdmin(
                                                e.target.checked ? 2 : "ไม่มีข้อมูล"
                                              )
                                            }
                                          ></Input>
                                        </InputGroupText>

                                        <Input
                                          disabled={
                                            typeSubAdminAll === "0" || status === 0
                                              ? true
                                              : false
                                          }
                                          readOnly
                                          placeholder="ระบบลงเวลาปฏิบัติงานแบบยืดหยุ่น"
                                        />
                                      </InputGroup>
                                      <InputGroup className="mb-1">
                                        <InputGroupText>
                                          <Input
                                            disabled={
                                              typeSubAdminAll === "0" ||
                                              status === 0
                                                ? true
                                                : false
                                            }
                                            name="users_position_sub_admin"
                                            type="checkbox"
                                            addon
                                            defaultChecked={subAdminCheck.some(
                                              i =>
                                                i.type_sub_admin === 3 &&
                                                i.status !== "0"
                                            )}
                                            // checked={
                                            //   type3SubAdmin === "ไม่มีข้อมูล"
                                            //     ? false
                                            //     : type3SubAdmin
                                            // }
                                            onChange={e =>
                                              setType3SubAdmin(
                                                e.target.checked ? 3 : "ไม่มีข้อมูล"
                                              )
                                            }
                                          ></Input>
                                        </InputGroupText>

                                        <Input
                                          disabled={
                                            typeSubAdminAll === "0" || status === 0
                                              ? true
                                              : false
                                          }
                                          readOnly
                                          placeholder="ระบบการประเมินผล การปฏิบัติราชการแบบออนไลน์"
                                        />
                                      </InputGroup>
                                      <InputGroup className="mb-1">
                                        <InputGroupText>
                                          <Input
                                            disabled={
                                              typeSubAdminAll === "0" ||
                                              status === 0
                                                ? true
                                                : false
                                            }
                                            name="users_position_sub_admin"
                                            type="checkbox"
                                            addon
                                            defaultChecked={subAdminCheck.some(
                                              i =>
                                                i.type_sub_admin === 4 &&
                                                i.status !== "0"
                                            )}
                                            // checked={
                                            //   type4SubAdmin === "ไม่มีข้อมูล"
                                            //     ? false
                                            //     : type4SubAdmin
                                            // }
                                            onChange={e =>
                                              setType4SubAdmin(
                                                e.target.checked ? 4 : "ไม่มีข้อมูล"
                                              )
                                            }
                                          ></Input>
                                        </InputGroupText>

                                        <Input
                                          disabled={
                                            typeSubAdminAll === "0" || status === 0
                                              ? true
                                              : false
                                          }
                                          readOnly
                                          placeholder="ระบบทรัพยากรออนไลน์"
                                        />
                                      </InputGroup>
                                      <InputGroup className="mb-1">
                                        <InputGroupText>
                                          <Input
                                            disabled={
                                              typeSubAdminAll === "0" ||
                                              status === 0
                                                ? true
                                                : false
                                            }
                                            name="users_position_sub_admin"
                                            type="checkbox"
                                            addon
                                            defaultChecked={subAdminCheck.some(
                                              i =>
                                                i.type_sub_admin === 5 &&
                                                i.status !== "0"
                                            )}
                                            onChange={e =>
                                              setType5SubAdmin(
                                                e.target.checked ? 5 : "ไม่มีข้อมูล"
                                              )
                                            }
                                          ></Input>
                                        </InputGroupText>

                                        <Input
                                          disabled={
                                            typeSubAdminAll === "0" || status === 0
                                              ? true
                                              : false
                                          }
                                          readOnly
                                          placeholder="ระบบจัดการข้อมูล"
                                        />
                                      </InputGroup>

                                      <InputGroup className="mb-1">
                                        <InputGroupText>
                                          <Input
                                            disabled={
                                              typeSubAdminAll === "0" ||
                                              status === 0
                                                ? true
                                                : false
                                            }
                                            name="users_position_sub_admin"
                                            type="checkbox"
                                            addon
                                            defaultChecked={subAdminCheck.some(
                                              i =>
                                                i.type_sub_admin === 6 &&
                                                i.status !== "0"
                                            )}
                                            onChange={e =>
                                              setType6SubAdmin(
                                                e.target.checked ? 6 : "ไม่มีข้อมูล"
                                              )
                                            }
                                          ></Input>
                                        </InputGroupText>

                                        <Input
                                          disabled={
                                            typeSubAdminAll === "0" || status === 0
                                              ? true
                                              : false
                                          }
                                          readOnly
                                          placeholder="ระบบจัดการไฟล์เงินเดือน"
                                        />
                                      </InputGroup>
                                    </FormGroup>
                                    {status === 0 ? (
                                      <div id="liveAlertPlaceholder">
                                        <Alert
                                          color="danger"
                                          className="text-danger"
                                          isOpen={status === 0}
                                        >
                                          ต้องเปิดการใช้งานจึงจะสามารถเลือกผู้ดูแลระบบย่อยได้
                                        </Alert>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </>
                                ) : (
                                  ""
                                )}
                              </Fragment>
                            : ""}

                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Col lg={6}>
                          <FormGroup>
                            <Label>วันที่เริ่ม</Label>
                            {/* <Input
                              defaultValue={dayjs
                                .utc(userEdit.date_start)
                                .format("YYYY-MM-DD")}
                              name="start_date"
                              type="date"
                              onChange={e => setStartDate(e.target.value)}
                            /> */}
                            <MyThaiDatePick placeholderText = "เลือกวันที่เริ่ม..." defaultValue = {userEdit.date_start} setProbsDate = {setStartDate}/>
                          </FormGroup>
                        </Col>

                        <Col lg={6}>
                          {userEdit.is_default === 1 &&
                          userEdit.status === 1 &&
                          statusCheck === false ? (
                            <FormGroup>
                              <Label>วันที่สิ้นสุด</Label>
                              {/* <Input
                                disabled
                                defaultValue={dayjs
                                  .utc(userEdit.date_end)
                                  .format("YYYY-MM-DD")}
                                name="date_end"
                                type="date"
                                invalid={true}
                                onChange={e => setEndDate(e.target.value)}
                              /> */}
                              <MyThaiDatePick minDate = {startDate} placeholderText = "เลือกวันที่สิ้นสุด..." defaultValue = {userEdit.date_end} setProbsDate = {setEndDate}/>
                              <FormFeedback>
                                ตำแหน่งหลักและสถานะการใช้งานจะไม่สามารถเปิดใช้งานพร้อมกันได้
                              </FormFeedback>
                            </FormGroup>
                          ) : (
                            <FormGroup>
                              <Label>วันที่สิ้นสุด</Label>
                              {/* <Input
                                defaultValue={dayjs
                                  .utc(userEdit.date_end)
                                  .format("YYYY-MM-DD")}
                                name="date_end"
                                type="date"
                                invalid={true}
                                onChange={e => setEndDate(e.target.value)}
                              /> */}
                              <MyThaiDatePick minDate = {startDate} placeholderText = "เลือกวันที่สิ้นสุด..." defaultValue = {userEdit.date_end} setProbsDate = {setEndDate}/>
                            </FormGroup>
                          )}
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={6}>
                          <InputGroup className="my-2">
                            <Input
                              readOnly
                              placeholder="Check it out"
                              defaultValue="ใช้งาน"
                              style={{
                                cursor: "pointer",
                                transition: "background-color 0.3s",
                              }}
                            />
                            <InputGroupText>
                              <Input
                                addon
                                defaultChecked={userEdit.status === 1}
                                // invalid={feedbackCheck}
                                type="checkbox"
                                name="status"
                                onChange={e =>
                                  setStatus(e.target.checked ? 1 : 0)
                                }
                              />
                            </InputGroupText>
                          </InputGroup>
                          {/* {feedbackCheck && (
                            <FormFeedback>โปรดกรอกข้อมูล</FormFeedback>
                          )} */}
                        </Col>

                        <Col lg={6}>
                          <InputGroup className="my-2">
                            <Input
                              readOnly
                              placeholder="Check it out"
                              defaultValue="ตำแหน่งหลัก"
                              style={{
                                cursor: "pointer",
                                transition: "background-color 0.3s",
                              }}
                            />
                            <InputGroupText>
                              <Input
                                addon
                                defaultChecked={userEdit.is_default === 1}
                                type="checkbox"
                                name="is_default"
                                onChange={e =>
                                  setIsDefault(e.target.checked ? 1 : 0)
                                }
                              />
                            </InputGroupText>
                          </InputGroup>
                        </Col>
                      </Row>
                    </Fragment>
                  );
                })}

                <br />
                <Row>
                  <Col md={4} lg={6} xl={6}></Col>
                  <Col
                    xs={12}
                    sm={12}
                    md={4}
                    lg={3}
                    xl={3}
                    style={{ display: "flex", justifyContent: "end" }}
                    className="mb-2"
                  >
                    <Button
                      type="submit"
                      color="success"
                      style={{ width: "100%" }}
                    >
                      บันทึก
                    </Button>
                  </Col>
                  <Col
                    xs={12}
                    sm={12}
                    md={4}
                    lg={3}
                    xl={3}
                    style={{ display: "flex", justifyContent: "end" }}
                    className="mb-2"
                  >
                    <Button
                      color="danger"
                      style={{ width: "100%" }}
                      onClick={toggleRightCanvasFS}
                    >
                      ยกเลิก
                    </Button>
                  </Col>
                </Row>
              </Form>
            </FadeIn>
          )}
        </OffcanvasBody>
      </Offcanvas>
    </Fragment>
  );
}

export default EditCommander;
